module.exports = {"prefix":"oman","logoEN":"oman_flag.gif","logoAR":"oman_flag.gif","logoWidth":"50px","mainImageEN":"main.jpg","mainImageAR":"main.jpg","baseColor":"#9dc51c","secondaryColor":"#daed59","themeColor":"#9dc51c","modules":{"statisticalTablesVisible":true,"keyIndustrialIndicatorsVisible":true,"directoryOfManufacturingVisible":true,"performanceMonitoringVisible":false,"publicationsVisible":false,"onlineSurveyVisible":false},"hasMenuDatabases":true,"hasFooterLinks":true,"hasSubfooterLinks":true,"md5Hash":"7e29d09e9ba2a6afc1fa88b742b7a383"}


//////////////////
// WEBPACK FOOTER
// ./src/features/tenant/config/oman.json
// module id = 859
// module chunks = 4